import { render, staticRenderFns } from "./vertical-diff.vue?vue&type=template&id=c451ae0c&"
import script from "./vertical-diff.vue?vue&type=script&lang=js&"
export * from "./vertical-diff.vue?vue&type=script&lang=js&"
import style0 from "./vertical-diff.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports